import { memo } from 'react';
import AIChatMessages, { type AIChatMessagesProps } from './AIChatMessages';
import AssistantToolResults from './AssistantToolResults';
import Conversation from './Conversation';
import Item from './Item';
import List from './List';
import MessagePart from './MessagePart';
import SubmittedLoader from './SubmittedLoader';
import ToolLoadingList from './ToolLoadingList';

export type AIChatMessagesBaseProps = Omit<AIChatMessagesProps, 'children'> & {
  className?: string;
  classNameContent?: string;
};

const AIChatMessagesBase = ({ className, classNameContent, ...rootProps }: AIChatMessagesBaseProps) => (
  <AIChatMessages {...rootProps}>
    <Conversation className={className} classNameContent={classNameContent}>
      <List />
      <SubmittedLoader />
    </Conversation>
  </AIChatMessages>
);

const Root = Object.assign(memo(AIChatMessagesBase), {
  AIChatMessages,
  Conversation,
  List,
  Item,
  MessagePart,
  ToolLoadingList,
  AssistantToolResults,
  SubmittedLoader,
});

export default Root;
